import { render } from "./DeliveryLocationsConditionForm.vue?vue&type=template&id=8148d820"
import script from "./DeliveryLocationsConditionForm.vue?vue&type=script&lang=js"
export * from "./DeliveryLocationsConditionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__